/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum StorageKey {
  FreezeLastState = 'freezeLastState',
  UUID = 'UUID',
  ConfigFile = 'configFile',
  ApisToCallOffline = 'apisToCallOffline',
  OfflineFile = 'offlineFile',
  Lang = 'lang',
  ActivationCode = 'activationCode',
  Attemps = 'attemps',
  Token = 'token',
}
